/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssessmentSummaryItem
 */
export interface AssessmentSummaryItem {
    /**
     * 
     * @type {string}
     * @memberof AssessmentSummaryItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentSummaryItem
     */
    name?: string;
}

/**
 * Check if a given object implements the AssessmentSummaryItem interface.
 */
export function instanceOfAssessmentSummaryItem(value: object): value is AssessmentSummaryItem {
    return true;
}

export function AssessmentSummaryItemFromJSON(json: any): AssessmentSummaryItem {
    return AssessmentSummaryItemFromJSONTyped(json, false);
}

export function AssessmentSummaryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentSummaryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AssessmentSummaryItemToJSON(json: any): AssessmentSummaryItem {
    return AssessmentSummaryItemToJSONTyped(json, false);
}

export function AssessmentSummaryItemToJSONTyped(value?: AssessmentSummaryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

